import { render, staticRenderFns } from "./ProductTypeDetailView.vue?vue&type=template&id=3223d292&scoped=true"
import script from "./ProductTypeDetailView.vue?vue&type=script&lang=js"
export * from "./ProductTypeDetailView.vue?vue&type=script&lang=js"
import style0 from "./ProductTypeDetailView.vue?vue&type=style&index=0&id=3223d292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3223d292",
  null
  
)

export default component.exports